/* Levano · site-wide fixes: trust card, US spelling, empty-cart link, folded reviews */
(function(){
  var MAIN_PRODUCT = '/products/levano-godesk-4-in-1-workstation-set';

  function q(s,r){return (r||document).querySelector(s)}
  function all(s,r){return [].slice.call((r||document).querySelectorAll(s))}

  /* ---------- fine line icons for the trust card ---------- */
  var ICONS = {
    /* parcel, drawn as a closed box seen from above-left */
    box:'<path d="M3.6 7.2 12 3l8.4 4.2v9.6L12 21l-8.4-4.2z"/><path d="M3.6 7.2 12 11.4l8.4-4.2"/><path d="M12 11.4V21"/><path d="M7.8 5.1 16.2 9.3v3"/>',
    /* shield with a check — the guarantee mark */
    shield:'<path d="M12 2.8 5 5.6v5.9c0 4.3 2.9 7.8 7 9.7 4.1-1.9 7-5.4 7-9.7V5.6z"/><path d="m8.9 11.9 2.2 2.2 4-4.3"/>',
    /* zip pouch */
    pouch:'<rect x="3.6" y="7.4" width="16.8" height="11.6" rx="2.4"/><path d="M3.6 11.1h16.8"/><path d="M8.6 7.4V6.2a3.4 3.4 0 0 1 6.8 0v1.2"/>',
    /* fallback */
    tick:'<circle cx="12" cy="12" r="8.6"/><path d="m8.4 12 2.4 2.4 4.8-4.8"/>'
  };
  function icon(name){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[name] + '</svg>';
  }
  function pick(text){
    var t = (text || '').toLowerCase();
    if (/ship|deliver|worldwide|in stock|free us/.test(t)) return 'box';
    if (/return|refund|money|guarantee|warrant|secure/.test(t)) return 'shield';
    if (/pouch|cable|tie|strap|includ|in every set|kit/.test(t)) return 'pouch';
    return 'tick';
  }

  function trustCard(){
    var box = q('.lvf-trust');
    if (!box || box.dataset.lvbIcons === '2') return;
    all('.lvf-trust__row', box).forEach(function(row){
      var slot = q('.lvf-check', row);
      if (slot) slot.innerHTML = icon(pick(row.textContent));
    });
    /* Shopify's own payment badges, parked in a <template> by lvb-pay.liquid */
    var src = q('#lvb-pay-src');
    if (src && !q('.lvb-pay', box)) box.appendChild(src.content.cloneNode(true));
    box.dataset.lvbIcons = '2';
  }

  /* ---------- US spelling ---------- */
  function spelling(){
    var map = [[/Colours/g,'Colors'],[/Colour/g,'Color'],[/colours/g,'colors'],[/colour/g,'color']];
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') continue;
      var v = n.nodeValue;
      if (v.indexOf('olour') === -1) continue;
      for (var i = 0; i < map.length; i++) v = v.replace(map[i][0], map[i][1]);
      n.nodeValue = v;
    }
  }

  /* ---------- "Continue shopping" always means the GoDesk page ---------- */
  function isShopLink(a){
    var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
    var t = (a.textContent || '').trim();
    if (/continue shopping|keep shopping|start shopping|shop now/i.test(t)) return true;
    return h === '' || h === '/collections/all' || /^\/collections(\/|$)/.test(h);
  }
  function continueShopping(root){
    all('a', root || document).forEach(function(a){
      if (a.getAttribute('data-lvb-cs')) return;
      if (!isShopLink(a)) return;
      if (!/continue shopping|keep shopping|start shopping/i.test(a.textContent || '')) {
        /* only rewrite bare collection links inside an empty cart */
        if (location.pathname.indexOf('/cart') !== 0) return;
        if (q('.cart-item')) return;
      }
      a.setAttribute('href', MAIN_PRODUCT);
      a.setAttribute('data-lvb-cs', '1');
    });
    /* buttons that navigate with JS rather than an href */
    all('button', root || document).forEach(function(b){
      if (b.getAttribute('data-lvb-cs')) return;
      if (!/continue shopping|keep shopping|start shopping/i.test(b.textContent || '')) return;
      b.setAttribute('data-lvb-cs', '1');
      b.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        window.location.href = MAIN_PRODUCT;
      }, true);
    });
  }

  /* the cart drawer lives in a shadow root */
  function drawerLinks(){
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) continueShopping(host.shadowRoot);
  }

  /* ---------- reviews stay short on a phone until asked ---------- */
  function foldReviews(){
    var box = q('.lvr-loox');
    if (!box || box.dataset.lvbFold) return;
    box.dataset.lvbFold = '1';
    box.classList.add('is-folded');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lvb-revmore';
    btn.textContent = 'Read all reviews';
    btn.addEventListener('click', function(){
      var folded = box.classList.toggle('is-folded');
      btn.textContent = folded ? 'Read all reviews' : 'Show fewer reviews';
      if (folded) box.scrollIntoView({ block: 'start' });
    });
    box.parentNode.insertBefore(btn, box.nextSibling);
  }

  function run(){ trustCard(); spelling(); continueShopping(); drawerLinks(); foldReviews(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  setInterval(function(){ continueShopping(); drawerLinks(); }, 900);
  var n = 0, t = setInterval(function(){ run(); if (++n > 10) clearInterval(t) }, 700);
})();
